import dayjs from "dayjs";

import { Option } from "@/@types/generics/Option";
import { ClinicOrSpecialtyOptionValue } from "@/components/sintegrada/Selects/ClinicOrSpecialtySelect";
import { defaultGender } from "@/components/GenderSelect";
import { defaultRiskClassification } from "@/components/sintegrada/Selects/RiskClassificationSelect";
import { defaultProfessional } from "@/components/sintegrada/Selects/ProfessionalSelect";
import { defaultIcd } from "@/components/sintegrada/Selects/IcdSelect";

const startDate = dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm");
const endDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

export type TypeofDiagnosticHypothesisFilterInitialValues =
	typeof diagnosticHypothesisFilterInitialValues;

export const diagnosticHypothesisFilterInitialValues = {
	startDate,
	endDate,
	clinicOrSpecialty: {} as Option<ClinicOrSpecialtyOptionValue>,
	icd: defaultIcd,
	riskClassification: defaultRiskClassification,
	gender: defaultGender,
	minAge: "",
	maxAge: "",
	professional: defaultProfessional,
	groupByProfessional: false,
};
